var _a;
import { createStore } from '../../util/createStore';
import { useEffect } from 'react';
var CurrencyLocaleCode;
(function (CurrencyLocaleCode) {
    CurrencyLocaleCode["NOK"] = "nb-NO";
    CurrencyLocaleCode["DKK"] = "dk-DK";
    CurrencyLocaleCode["EUR"] = "et-EE";
})(CurrencyLocaleCode || (CurrencyLocaleCode = {}));
export var Currency;
(function (Currency) {
    Currency["NOK"] = "NOK";
    Currency["DKK"] = "DKK";
    Currency["EUR"] = "EUR";
})(Currency || (Currency = {}));
var numberFormatNok = new Intl.NumberFormat(CurrencyLocaleCode.NOK, {
    style: 'currency',
    currency: Currency.NOK,
    minimumFractionDigits: 2,
});
var numberFormatByLocaleCurrency = (_a = {},
    _a[Currency.NOK] = numberFormatNok,
    _a[Currency.DKK] = new Intl.NumberFormat(CurrencyLocaleCode.DKK, {
        style: 'currency',
        currency: Currency.DKK,
        minimumFractionDigits: 2,
    }),
    _a[Currency.EUR] = new Intl.NumberFormat(CurrencyLocaleCode.EUR, {
        style: 'currency',
        currency: Currency.EUR,
        minimumFractionDigits: 2,
    }),
    _a);
var useStore = createStore(Currency.NOK).useStore;
export function useCurrency() {
    var _a = useStore(), currency = _a[0], setCurrency = _a[1];
    var numberFormat = numberFormatByLocaleCurrency[currency] || numberFormatNok;
    return {
        getSymbol: function () {
            return currency;
        },
        useRegister: function (currency) {
            useEffect(function () {
                setCurrency(currency);
            }, [currency]);
        },
        setCurrency: setCurrency,
        format: function (number, currency) {
            var formatter = numberFormatByLocaleCurrency[currency] || numberFormat;
            return formatter.format(number / 100).replace(',00', '');
        },
    };
}
